module.exports = __webpack_public_path__ + "img/icons/presentation-f2806a2ce8ae53ce873ed46a5a22b4fd.svg";